export default {
    url: '/rooms',
    template: `
        <ui-view></ui-view>
    `,
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/rooms/index.js